import { WebSdkService } from 'src/app/shared/services/web-sdk/web-sdk.service';
import { DatacontextService } from 'src/app/data/datacontext.service';
import * as i0 from "@angular/core";
import * as i1 from "../web-sdk/web-sdk.service";
import * as i2 from "../../../data/datacontext.service";
var TrialUserService = /** @class */ (function () {
    function TrialUserService(webSdkService, datacontextService) {
        this.webSdkService = webSdkService;
        this.datacontextService = datacontextService;
        this.companyDetails = {};
        this.trialUserData = {};
        this.dilWhitelist = [];
        this.trialWhiteList = [];
        if (Object.keys(this.trialUserData).length === 0) {
            this.getCompanyInfo();
        }
        // setting isTrialUser flag to false.
        this.trialUserData.istrialUser = false;
    }
    TrialUserService.prototype.getCompanyInfo = function () {
        var _this = this;
        this.datacontextService.user.getUserCompany(function (res) {
            var _companyDetails = res.api_response.companies[0];
            delete _companyDetails.apps;
            _this.companyDetails = _companyDetails;
            var isSDKReady = window.setInterval(function () {
                if (_this.webSdkService.sdkReady) {
                    window.clearInterval(isSDKReady);
                    _this.getTrialStartDate();
                }
            }, 1000);
        });
    };
    TrialUserService.prototype.checkTrialUser = function () {
        var trialStartDate = new Date(this.trialStDt);
        var ts = this.companyDetails.ts;
        var userCreateData = new Date(ts);
        var isUserWhitelisted = this.trialWhiteList.includes(this.companyDetails.id);
        this.trialUserData.istrialUser = false;
        this.trialUserData.enableDIL = this.dilWhitelist.includes(this.companyDetails.id);
        if (this.trialUserData.istrialUser) {
            this.getTrialPeriodCounDown(userCreateData);
        }
    };
    TrialUserService.prototype.getTrialPeriodCounDown = function (dateCreated) {
        var next30days = new Date(dateCreated.setDate(dateCreated.getDate() + 30));
        var today = new Date();
        var diffTime = next30days.getTime() - today.getTime();
        this.trialUserData.trialDaysRemaining = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    };
    TrialUserService.prototype.getTrialStartDate = function () {
        var _this = this;
        this.webSdkService.getData('string', 'trialStartDate', '').then(function (date) {
            _this.trialStDt = date;
            _this.getTrialWhiteList();
            // this.checkTrialUser(date);
        });
    };
    TrialUserService.prototype.getTrialWhiteList = function () {
        var _this = this;
        this.webSdkService.getData('JSON', 'trial-whitelist', []).then(function (trialWhiteList) {
            _this.trialWhiteList = trialWhiteList;
            _this.getDILWhiteList();
        });
    };
    TrialUserService.prototype.getDILWhiteList = function () {
        var _this = this;
        this.webSdkService.getData('JSON', 'dil-whitelist', []).then(function (whitelist) {
            _this.dilWhitelist = whitelist;
            _this.checkTrialUser();
        });
    };
    TrialUserService.ngInjectableDef = i0.defineInjectable({ factory: function TrialUserService_Factory() { return new TrialUserService(i0.inject(i1.WebSdkService), i0.inject(i2.DatacontextService)); }, token: TrialUserService, providedIn: "root" });
    return TrialUserService;
}());
export { TrialUserService };
